import { ResizeObserver } from "@juggle/resize-observer";

if (typeof window !== "undefined") {
  if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver;
  }
}
